import api from '../../../api';

export const getBrevoAccount = async () => {
    try {
        const response = await api.get('/brevo/account');
        return response.data;
    } catch (error) {
        console.error("Erreur récupération compte Brevo", error);
        throw error;
    }
};

export const getBrevoCampaigns = async () => {
    try {
        const response = await api.get('/brevo/campaigns');
        return response.data;
    } catch (error) {
        console.error("Erreur récupération campagnes", error);
        throw error;
    }
};

export const createBrevoCampaign = async (campaignData) => {
    try {
        const response = await api.post('/brevo/campaigns', campaignData);
        return response.data;
    } catch (error) {
        console.error("Erreur création campagne", error);
        throw error;
    }
};

export const getBrevoLists = async () => {
    try {
        const response = await api.get('/brevo/lists');
        return response.data;
    } catch (error) {
        console.error("Erreur récupération listes", error);
        throw error;
    }
};

export const createBrevoList = async (listData) => {
    try {
        const response = await api.post('/brevo/lists', listData);
        return response.data;
    } catch (error) {
        console.error("Erreur création liste", error);
        throw error;
    }
};

export const syncBrevoContacts = async (listId, contacts) => {
    try {
        const response = await api.post('/brevo/sync', { listId, contacts });
        return response.data;
    } catch (error) {
        console.error("Erreur synchro contacts", error);
        throw error;
    }
};

export const sendBrevoTest = async (testData) => {
    try {
        const response = await api.post('/brevo/send-test', testData);
        return response.data;
    } catch (error) {
        console.error("Erreur envoi email test", error);
        throw error;
    }
};

